import { computed } from 'vue'

import type { ComputedRef } from 'vue'

import { resolveUrl } from '@shared/lib/url'
import { AppRoute, TasksKanbanRelatedToType } from '@shared/config'

import { useTasksKanbanStore } from './store'

interface RelatedToRouteConfig {
  path: AppRoute
  label: string
}

const routeConfigByType: Record<TasksKanbanRelatedToType, RelatedToRouteConfig> = {
  [TasksKanbanRelatedToType.Customer]: {
    path: AppRoute.CustomersShow,
    label: 'Customer',
  },
  [TasksKanbanRelatedToType.Discipline]: {
    path: AppRoute.DisciplinesGeneralInfo,
    label: 'Discipline',
  },
  [TasksKanbanRelatedToType.Subscription]: {
    path: AppRoute.CustomersSubscriptions,
    label: 'Subscription',
  },
}

interface TaskRelationRelatedToReturn {
  refHasRelatedTo: ComputedRef<boolean>
  refHref: ComputedRef<string>
  refLabel: ComputedRef<string>
}

export const useTaskRelationRelatedTo = (): TaskRelationRelatedToReturn => {
  const tasksKanbanStore = useTasksKanbanStore()

  const refHasRelatedTo = computed<boolean>(() => !!tasksKanbanStore.getRelatedTo)

  const refHref = computed<string>(() => {
    const relatedTo = tasksKanbanStore.getRelatedTo
    if (!relatedTo) return ''

    const config = routeConfigByType[relatedTo.type]
    const customerId = tasksKanbanStore.getCustomer?.id

    if (relatedTo.type === TasksKanbanRelatedToType.Subscription && customerId) {
      return resolveUrl(config.path, { id: customerId }) ?? ''
    } else {
      return resolveUrl(config.path, { id: relatedTo.id }) ?? ''
    }
  })

  const refLabel = computed<string>(() => {
    const relatedTo = tasksKanbanStore.getRelatedTo
    if (!relatedTo) return ''

    if (relatedTo.type === TasksKanbanRelatedToType.Discipline && relatedTo.kidName && relatedTo.code) {
      return `${relatedTo.kidName} - ${relatedTo.code} #${relatedTo.id}`
    }

    return `${routeConfigByType[relatedTo.type].label} #${relatedTo.id}`
  })

  return {
    refHasRelatedTo,
    refHref,
    refLabel,
  }
}
